import React from "react";
import bookmarkimg from '../../assets/images/bookmarkimg.png';
import { useTranslation } from 'react-i18next';
function Favouritestitle(props) {
    const { t } = useTranslation();
  return (

    <div className="Favourites_title">
          <div className="Favourites_title_l">
             <img className="bookmarkimg" src={bookmarkimg} alt="" width="23" height="33" />
             <h2>{props.title}</h2>
          </div>
          <div className="Favourites_title_r">
            <p>{props.currentCount} {t('of')} {props.itemCount} {t('items_txt')}</p>
          </div>
        </div>
    );
}

export default Favouritestitle;
